// Install polyfills before doing anything else.
import 'es6-promise'; // http://www.html5rocks.com/en/tutorials/es6/promises/
import 'isomorphic-fetch'; // https://developer.mozilla.org/en/docs/Web/API/Fetch_API
import 'setimmediate'; // https://github.com/yuzujs/setImmediate
import 'babel-polyfill';
import 'promise-polyfill/dist/polyfill';
import 'abortcontroller-polyfill';
import './iePoyfills';

import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {hashHistory} from 'react-router';
import {syncHistoryWithStore} from 'react-router-redux';
import {persistStore} from 'redux-persist';
import localForage from 'localforage';
import App from './components/app';
import configureStore from './stores';
import {PersistStoreWhitelist} from './reducers';
import Cookies from 'cookies-js';
import {login} from './actions';
import TranslatesProvider from "./translates/translatesProvider";

export const store = configureStore();
const history = syncHistoryWithStore(hashHistory, store);

window.managing = Cookies.get('managing');

class Root extends Component {
  state = {
    rehydrated: false,
    auth: document.auth
  }
  htmlDecode = (input) => {
    var e = document.createElement('textarea');
    e.innerHTML = input;
    // handle case of empty input
    return e.childNodes.length === 0 ? "" : e.childNodes[0].nodeValue;
  }

  componentWillMount() {
    persistStore(store, {
      store: localForage,
      whitelist: PersistStoreWhitelist
    }, () => {
      this.setState({rehydrated: true});
    });

    if(this.state.auth) {
      store.dispatch(login()).then(() => {
        var redirectTo = (document.onAuthRedirectTo || '');
        if(redirectTo !== '') {
          var redirect = this.htmlDecode(decodeURIComponent(document.onAuthRedirectTo));
          document.location = redirect;
        }

        if(redirectTo == '' || (redirectTo.length > 0 && redirectTo[0] == '#'))
          this.setState({auth: false});
      });
    }
  }

  render() {
    if ((!this.state.rehydrated) || this.state.auth) {
      return <div>Loading...</div>;
    }
    return (
      <Provider store={store}>
        <TranslatesProvider>
          <App history={history}/>
        </TranslatesProvider>
      </Provider>
    );
  }
}

ReactDOM.render(<Root/>, document.getElementById('app'));
